/**
 * The set-up checklist: how each step is worded and where it goes. WHICH steps an organization has, and whether each is done, is decided by
 * the server (SetupChecklistService, `GET /api/setup-checklist`, Org Admin only); a key this version does not know is simply not shown.
 * To add a step: the server decides it (and its test), then add its wording here.
 */
export const SETUP_STEPS = {
  'business-details': {
    title: 'Add your business and GST details',
    hint: 'GSTIN, legal name and state. They print on every tax invoice and decide how GST is split.',
    to: '/org-admin/settings',
    label: 'Open Org settings'
  },
  locations: {
    title: 'Add a place to hold stock',
    hint: 'A warehouse, a retail store or a production unit. Stock is always held somewhere.',
    to: '/org-admin/warehouses',
    label: 'Add a warehouse'
  },
  items: {
    title: 'Add your materials and products',
    hint: 'Search the Global Material Master and press + Add, or create your own. Already hold stock? Enter it as you add.',
    to: '/org-admin/organization-materials',
    label: 'Add materials'
  },
  vendors: {
    title: 'Add your vendors',
    hint: 'Who you buy from. Bring in a list from a spreadsheet or Tally if you have one.',
    to: '/purchase/vendors',
    label: 'Add vendors'
  },
  customers: {
    title: 'Add your customers',
    hint: 'Who you sell to, with their GSTIN and credit terms.',
    to: '/sales/customers',
    label: 'Add customers'
  },
  bank: {
    title: 'Add your bank account',
    hint: 'It prints on your invoices with a UPI QR, and bank reconciliation reads its statements.',
    to: '/accounts/bank-accounts',
    label: 'Add a bank account'
  },
  opening: {
    title: 'Enter your opening balances',
    hint: 'Moving from other books? Bring in what customers owe, what you owe and your stock, as at one date.',
    to: '/accounts/opening-balances',
    label: 'Open Opening Balances'
  },
  team: {
    title: 'Invite your team',
    hint: 'Give each person a role, so they see only what they need.',
    to: '/org-admin/users',
    label: 'Add users'
  }
};

/** The server's steps with their wording, in the server's order; steps this version has no wording for are left out. */
export function describeSteps(serverSteps) {
  return (serverSteps || [])
    .filter((s) => SETUP_STEPS[s.key])
    .map((s) => ({ ...SETUP_STEPS[s.key], key: s.key, done: !!s.done, optional: !!s.optional }));
}

/** How many of the required steps are done: the optional ones are listed but never counted. */
export function progress(steps) {
  const required = steps.filter((s) => !s.optional);
  return { done: required.filter((s) => s.done).length, total: required.length };
}
